export default function wrapLink() {
  const targets = document.querySelectorAll('[data-wrap-link]');

  targets.forEach((root) => {
    const link = root.querySelector('[data-wrap-link-href]');
    if (link) {
      const url = link.getAttribute('href');
      const target = link.getAttribute('target');

      root.addEventListener('click', (event) => {
        const selection = document?.getSelection()?.toString();
        if (!selection || selection === '') {
          event.preventDefault();
          Object.assign(document.createElement('a'), {
            target: target || '_self',
            rel: target !== '_self' ? 'noopener noreferrer' : '',
            href: url,
          }).click();
        }
      });
    }
  });
}
